// extracted by mini-css-extract-plugin
export default {"modalOverlay":"PopupWrapper_modalOverlay__A6MAg","modalContent":"PopupWrapper_modalContent__ZiBaA","closeIcon":"PopupWrapper_closeIcon__Xbsno"};